<script lang="ts" setup>
defineProps<{
  sku: string
  isMobile: boolean
}>()
</script>

<template>
  <!-- v-show sets display: none, inova's script will assess the sku and set the display: block if it deems vto is available -->
  <div v-show="false" class="virtual-try-on" :id="isMobile ? 'BtnTryOnMob' : 'BtnTryOn'" :data-pdp-vto-sku="sku">
    <Button id="pdp-vto-button" class="virtual-try-on__button" variant="secondary">
      {{ $t('product_details_page.virtual_try_on.button.try_on') }}
    </Button>
  </div>
</template>

<style lang="postcss">
.virtual-try-on {
  .virtual-try-on__button {
    padding: var(--space-30) var(--space-50);
    min-height: 0;
    min-width: 0;
    font-size: var(--text-xsmall);
  }
}
</style>
